import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-etiquetadores-cultivo',
    templateUrl: './etiquetadores-cultivo.component.html'
})
export class EtiquetadoresCultivoComponent implements OnInit {

    private readonly _DEFAULIT_ITEMS_PER_PAGE = 5;

    public itemsPerPage = this._DEFAULIT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    @Input() etiquetadoresCultivo;

    constructor(private readonly _translate: TranslateService) {}

    ngOnInit() {

    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public trackByEtiquetadorId(index: number, etiquetador: { etiquetadorId: number }): number {
      return etiquetador.etiquetadorId;
    }
}
